import startCase from "lodash/startCase";
const OPTION_TOKENS = new Set([
    "xs",
    "s",
    "m",
    "l",
    "xl",
    "xxl",
    "small",
    "medium",
    "large",
    "yes",
    "no",
    "1",
    "2",
    "red",
    "blue",
]);
export function usePreferenceHeuristics(category, optionNames = []) {
    const normalize = (s) => s.trim().toLowerCase();
    const looksLikeOption = !!category && (OPTION_TOKENS.has(normalize(category)) || optionNames.some((n) => normalize(n) === normalize(category)));
    const seen = new Set();
    const duplicateNames = optionNames
        .map((n) => startCase(n.trim()))
        .filter((n) => {
        const key = n.toLowerCase();
        if (seen.has(key))
            return true;
        seen.add(key);
        return false;
    });
    return { looksLikeOption, duplicateNames };
}
